import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "server-and-resolvers"
    }}>{`Server And Resolvers`}</h1>
    <p>{`We have used grapgh-yoga as graphql server. All the server code is reside in `}<inlineCode parentName="p">{`packages/server`}</inlineCode>{` folder. Check the below image for server folder structure`}</p>
    <p><img alt="Resolvers.png" src={require("./images/Resolvers.png")} /></p>
    <p>{`Now let me wal you through the whole process.`}</p>
    <p><strong parentName="p">{`TypeDefs.js:`}</strong>{` It is the file where we have defined all our graphql types, query and mutations and input`}</p>
    <p><strong parentName="p">{`Resolvers:`}</strong>{` Here is the functionality to fetch and put data to firebase.`}</p>
    <p><strong parentName="p">{`Middlewares:`}</strong>{` Here we have restricted the routes for unauthorized access.`}</p>
    <p><strong parentName="p">{`lib:`}</strong>{` In this folder we have written all the function to access the firestore database. In the resolvers we have used this function to fetch or put data in the firestore.`}</p>
    <p>{`In the helper folder ther are all the helper function and in functions there is a google cloud function to make a thumb of the image during upload.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      